<app-dialog title="{{title}}">
  <content fxLayout="column">
    {{data.content}}
  </content>
  <footer select="footer" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="onSave()" *ngIf="alertMode">ยืนยัน</button>
    <button mat-raised-button color="warn" (click)="onClose()">ยกเลิก</button>
  </footer>
</app-dialog>
